var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"cursor":"pointer"},attrs:{"title":"Add item to tour"}},[_c('img',{class:_vm.item.mapLayerItemTypeID == 101
                ? 'mapitem-type-icon waypoint-icon'
                : 'mapitem-type-icon',attrs:{"src":_vm.getMapItemIcon(_vm.item.mapLayerItemTypeID)}}),_c('span',{staticClass:"map-item-title"},[_vm._v(_vm._s(_vm.item.title))])])}
var staticRenderFns = []

export { render, staticRenderFns }